import { IMessage } from "../../model/Message";
import { createAction, ActionsUnion } from "../definitions";
import { MessageActionTypes } from "./types";

export interface IMessagePayload {
    userId: string;
    messages?: IIdDictionary<IMessage>;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const MessageActions = {
    clearMessages: (payload: IMessagePayload) => createAction(MessageActionTypes.CLEAR_MESSAGES, payload),
    setMessages: (payload: IMessagePayload) => createAction(MessageActionTypes.SET_MESSAGES, payload)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type MessageActions = ActionsUnion<typeof MessageActions>;